export function SET_FORM(state, isIssueArea) {
  state.isIssueArea = isIssueArea;
}

export function SET_ISSUE_AREA(state, issueArea) {
  state.issueArea = issueArea;
}

export function CLEAN_ISSUE_AREA(state) {
  state.issueArea = [];
}
